module.exports = __webpack_public_path__ + "img/DS1525+.0021d925.png";